import { render, staticRenderFns } from "./OrionAdmin.vue?vue&type=template&id=5ca56d8a&scoped=true&"
import script from "./OrionAdmin.vue?vue&type=script&lang=js&"
export * from "./OrionAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca56d8a",
  null
  
)

export default component.exports